import apiConfig from "constants/apiConfig";
import { NewUser, User, UserListPayload, UserListResponse } from "types/users";
import axiosClient from "utils/axiosClient";

export const fetchUsers = async (agencyId: string, payload: UserListPayload): Promise<UserListResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_USERS.url.replace('<agencyId>', agencyId), { params: { ...payload } });
    return response.data;
}

export const fetchUser = async (agencyId: string, userId: string): Promise<User> => {
    const response = await axiosClient.get(apiConfig.FETCH_USER.url.replace('<agencyId>', agencyId).replace('<userId>', String(userId)));
    return response.data.user;
}

export const createNewUser = async (agencyId: string, payload: NewUser) => {
    const response = await axiosClient.post(apiConfig.CREATE_USER.url.replace('<agencyId>', agencyId), payload);
    return response.data;
}

export const updateUser = async (agencyId: string, userId: string | string, payload: NewUser) => {
    const response = await axiosClient.put(apiConfig.UPDATE_USER.url.replace('<agencyId>', agencyId).replace('<userId>', String(userId)), payload);
    return response.data;
}

export const fetchUserBrands = async (agencyId: string, payload: any = {}) => {
    const response = await axiosClient.get(apiConfig.FETCH_USER_BRANDS.url.replace('<agencyId>', agencyId), {params: payload});
    return response.data.results;
}

export const fetchRoles = async () => {
    const response = await axiosClient.get(apiConfig.FETCH_ROLES.url);
    return response.data.items;
}

export const deleteUser = async (agencyId: string, userId: string | string) => {
    const response = await axiosClient.delete(apiConfig.UPDATE_USER.url.replace('<agencyId>', agencyId).replace('<userId>', String(userId)));
    return response.data;
}